<template>
  <footer class="bg-white sticky-footer">
    <div class="container my-auto">
      <div class="text-center my-auto copyright">
        <span>Copyright © Kirill Harevich 2021</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue